import React from "react";
import styled from "@emotion/styled";
import Shared02Headings from "../../../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const ContainerDiv = styled.div`
  .slide__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* CLAVE: comportamiento tipo background */
    z-index: 0;
    pointer-events: none; /* El video no captura eventos */
  }
`;

const Card03 = ({ options }) => {
  //Des
  const { objinfo } = options;
  const { _id, card_heading, card_content } = objinfo;

  return (
    <ContainerDiv className="slide card-02" key={_id}>
      <div className="card">
        <video loop autoPlay muted playsinline={true} className="slide__video">
          <source src={card_content.src_content} type="video/mp4"></source>
        </video>

        <Shared02Headings options={card_heading} />
      </div>
    </ContainerDiv>
  );
};

export default Card03;
